import { Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';

interface IEntitlementInformation {
  information: string;
  contact?: string;
}

export const EntitlementInformation = ({
  information,
  contact,
}: IEntitlementInformation) => {
  const isDesktop = useIsDesktop();

  return (
    <Stack gap={isDesktop ? '8px' : '20px'}>
      <Typography
        variant={'body3'}
        tabIndex={0}
        padding={isDesktop ? '0 20% 0 0' : '0'}
        textOverflow='ellipsis'
        sx={{
          overflow: 'hidden',
          display: '-webkit-box',
          WebkitLineClamp: isDesktop ? '2' : '3',
          WebkitBoxOrient: 'vertical',
          textOverflow: 'ellipsis',
        }}
      >
        {information}
      </Typography>
      {contact && (
        <Typography variant={'body4'}>
          {Dictionary[DICTIONARY.CompassRights].entitlements.contact} {contact}
        </Typography>
      )}
    </Stack>
  );
};
